import { useMapaState } from "./useMapaState";
import { MapaContent } from "./MapaContent";

export const MapaWrapper = ({ onDireccionChange, initialLatLng, whatsAppProps, mostrarTalleres }) => {
  const {
    latLng,
    setLatLng,
    direccionActual,
    loadingDireccion,
    setLoadingDireccion,
    handleDireccionChange,
    talleres,
    talleresVisibles,
    handleTalleresLoad,
    handleTalleresToggle,
  } = useMapaState(initialLatLng);

  return (
    <MapaContent
      latLng={latLng}
      setLatLng={setLatLng}
      onConfirmar={onDireccionChange}
      direccionActual={direccionActual}
      onDireccionInterna={handleDireccionChange}
      onLoadingDireccion={setLoadingDireccion}
      loadingDireccion={loadingDireccion}
      whatsAppProps={whatsAppProps}
      talleresProps={
        mostrarTalleres
          ? {
              talleres: talleresVisibles ? talleres : null,
              talleresData: talleres,
              activos: talleresVisibles,
              onTalleresLoad: handleTalleresLoad,
              onToggle: handleTalleresToggle,
            }
          : undefined
      }
    />
  );
};
